module.exports = _.trim;